<p-toolbar styleClass="">
  <ng-template pTemplate="left">
    <button pButton pRipple label="New" icon="pi pi-plus" class="p-button-success mr-2" (click)="addSecurityGroup($event)"></button>
    <button pButton pRipple [label]="Delete" icon="pi pi-trash" class="p-button-danger" (click)="buttonClick($event)"
            [disabled]="false"></button>
  </ng-template>

  <ng-template pTemplate="right">
    <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help mr-2" (click)="buttonClick($event)"></button>
    <p-button icon="pi pi-reset" label="Обновить" class="" (onClick)="reloadTable($event)"
              pTooltip="Обновить содержимое таблицы" tooltipPosition="top"></p-button>
  </ng-template>
</p-toolbar>
<div *ngIf="securityGroupsEditor else sgLoading">

  <p-table #SG1 [value]="securityGroupsEditor"
           [rowHover]="true"
           [resizableColumns]="true"
           editMode="row"
           dataKey="uid"
           stateStorage="local"
           [(selection)]="selectedSecurityGroup"
           stateKey="securityGroups-state"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th style="text-align:center; width:8rem">...</th>
        <th pSortableColumn="SECGROUPID" pResizableColumn width="15%">Группа <p-sortIcon [field]="SECGROUPID"></p-sortIcon></th>
        <th pSortableColumn="SECGROUPNAME" pResizableColumn width="25%">Имя группы <p-sortIcon [field]="SECGROUPNAME"></p-sortIcon>
        <th pSortableColumn="SECGROUPDESC" pResizableColumn width="45%">Описание группы <p-sortIcon [field]="SECGROUPDESC"></p-sortIcon></th>
        <th pSortableColumn="SECGROUPFLAG" pResizableColumn width="15%">Флаги <p-sortIcon [field]="SECGROUPFLAG"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-sg let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="sg">
        <td style="text-align:left">
          <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(sg)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(sg)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(sg, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="sg.SECGROUPID" [style]="{'width':'100%'}">
            </ng-template>
            <ng-template pTemplate="output">
              {{sg.SECGROUPID}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="sg.SECGROUPNAME" [style]="{'width':'100%'}">
            </ng-template>
            <ng-template pTemplate="output">
              {{sg.SECGROUPNAME}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="sg.SECGROUPDESC" [style]="{'width':'100%'}">
            </ng-template>
            <ng-template pTemplate="output">
              {{sg.SECGROUPDESC}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="sg.SECGROUPFLAG" [style]="{'width':'100%'}">
            </ng-template>
            <ng-template pTemplate="output">
              {{sg.SECGROUPFLAG}}
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">нет данных для загрузки</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #sgLoading>
  <p>Информация загружается...</p>
</ng-template>
